module.exports = __webpack_public_path__ + "img/home-1080.5ded0476.webp";